var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"}},[(_vm.$route.query.tab != 'unBind')?_c('el-tab-pane',{attrs:{"label":"门禁设备"}},[_c('AccessControlDeviceOne')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }